<template>
  <filter-field label='Location'
                name='location_id'
                styles='width: 140px'
                placeholder='-- location -- '
                type='select'
                :list='locations'
                :display='display'
  />
</template>

<script>
  export default {
    name: 'filterFieldLocations',
    props: {
      display: Boolean
    },
    computed: {
      locations () {
        const locations = _.orderBy(this.$store.state.locations, 'business_name') || []
        return locations.map(location => ({id: location.location_id, info: location.business_name}))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/filter/filterFieldLocations.vue